module.exports = __webpack_public_path__ + "static/media/testfile_smartObject.bdb70d95.zip";